import { style } from "@vanilla-extract/css";
import {
  addElementCellWidth,
  elementInTableCellWidth,
  statCellWidth,
  statusCellWidth,
  vars,
} from "plos/src/styles";

export const elementListWrap = style({
  display: "flex",
  flexDirection: "column",
});

export const elementListTable = style({
  tableLayout: "fixed",
});

export const filtersWrap = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
});

export const tableHeader = style({
  padding: `${vars.space.xs} 0`,
  whiteSpace: "nowrap",
  color: vars.colors.onSurface,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.l,
});

export const elementListStatus = style({
  width: statusCellWidth,
});

export const elementListElement = style({
  alignItems: "center",
  width: elementInTableCellWidth,
  textAlign: "start",
});

export const elementListStat = style({
  width: statCellWidth,
  overflow: "hidden",
  color: vars.colors.onSurfaceVariant,
  fontSize: vars.fontSizes.body.s,
});

export const addElementColumn = style({
  width: addElementCellWidth,
});

export const elementSheetWrapper = style({
  padding: `0 ${vars.space.m} ${vars.space.xs} ${vars.space.m}`,
});

export const tablesWrap = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
  paddingTop: vars.space.xs,
});
